import axios from 'axios';
import qs from 'qs';
import apis from './api';
import router from '@/router';
import store from '@/store'
import api from './api';
let Base64 = require('js-base64').Base64
// let token = Base64.decode(basejm);
import common from '../common/common'
import Vue from '../main';
axios.defaults.baseURL = '/api';
// 新增
const pending = new Map();
// end
// console.log(basejm)
//创建axios实例
var instance = axios.create({
	// baseURL: config.baseURL,
	timeout: 100000,
	headers: {
		'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
	},
	transformRequest: [function (data = {}) {
		//在向服务器发送前，修改请求数据
		return data instanceof FormData ? data : qs.stringify(data)
	}],
	withCredentials: true
})
// 添加响应拦截器
instance.interceptors.response.use(function (response) {
	const responseData = response.data;
	// console.log(responseData)


	if (responseData.code == 0 || responseData.code == 200) {
		//返回自定义信息
		return Promise.resolve(responseData);
	} else if (responseData.code == -1) {
		router.replace({
			name: 'signin',
			query: {
				redirect: router.currentRoute.fullPath
			}
		})
		return Promise.reject(responseData);
		// router.push('/signin')
	} else if (responseData.code == 502) {
		common.signout(Vue)
		window.localStorage.removeItem('userInfo');
		store.commit("userInfo", '')
		// window.location.reload();
		return Promise.reject(responseData);
	} else {
		return Promise.reject(responseData);
	}
}, function (error) {
	//提示
	// message.error('服务器无响应')
	//响应
	return Promise.reject(error);
});

const fetch = function (axiosInstance, apiMap) {

	let http = {}
	//填充http
	Object.keys(apiMap).forEach(requestMethod => {
		const method = apiMap[requestMethod]
		Object.keys(method).forEach(api => {
			http[api] = data => {
				// console.log(store.state.user)
				let basejm
				if (store.state.user) {
					basejm = store.state.user.access_token;
				}
				let params = '?store_id=1&_version=2.8.9&_platform=pc'
				if (basejm) {
					params += '&access_token=' + basejm;
				}
				return axiosInstance({
					url: method[api] + params,
					method: requestMethod,
					[requestMethod.toUpperCase() === 'POST' ? 'data' : 'params']: data
				})
			}
		})
	})
	return http
}
// 新增
/**
 * 添加请求
 * @param {Object} config
 **/
const addPending = config => {
    const url = [
        config.method,
        config.url,
        qs.stringify(config.data),
        qs.stringify(config.params),
    ].join('');
    if (pending.has(url)) {
        // console.log(pending.get(url));
 
        // 如果 pending 中存在当前请求则取消后面的请求
        config.cancelToken = new axios.CancelToken(cancel => {
            cancel(`重复的请求被主动拦截: ${url}`);
        });
    } else {
        // 如果 pending 中不存在当前请求，则添加进去
        config.cancelToken =
            config.cancelToken ||
            new axios.CancelToken(cancel => {
                pending.set(url, cancel);
                // pending.add(url);
            });
    }
};
/**
 * 移除请求
 * @param {Object} config
 */
const removePending = config => {
    const url = [
        config.method,
        config.url.replace(config.baseURL, ''), // 响应url会添加域名，需要去掉与请求URL保持一致
        qs.stringify(config.data), // 需要与request的参数结构保持一致，request中是对象，response中是字符串
        qs.stringify(config.params),
    ].join('');
    if (pending.has(url)) {
        // 如果在 pending 中存在当前请求标识，取消当前请求，并且移除
        pending.delete(url);
    }
};
 
// 添加请求拦截器
axios.interceptors.request.use(
    function (config) {
        addPending(config); // 将当前请求添加到 pending 中
        return config;
        // 在发送请求之前做些什么
    },
    function (error) {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
);
// 添加响应拦截器
axios.interceptors.response.use(
    function (response) {
        removePending(response.config); // 在请求结束后，移除本次请求
        return response;
    },
    function (err) {
        if (err && err.config) {
            removePending(err.config); // 在请求结束后，移除本次请求
        }
        // 对响应错误做点什么
        return Promise.reject(err);
    }
);
// app.config.globalProperties.axios = axios;
 
router.beforeEach((to, from, next) => {
    // console.log('router.beforeEach');
    if (pending.sie > 0) {
        for (const [key, cancel] of pending) {
            cancel("取消所有请求");
        }
        pending.clear();
    }
    next();
});




export default fetch(instance, apis)
